import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import {
  onGoBack,
  // SERVER_TIMEZONE
} from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import {
  getTableCaseByCaseId,
  getVhnPpcValue,
  insertComplianceApp,
  updateTableCaseByPrimaryId,
  updateTableWiseCaseByCaseId,
  getHospitalByCustomerNo
} from '../../utils/db';
import withTableName from '../../common/withTableName';
import withUser from '../../common/withUser';
import withNotify from '../../common/withNotify';
import withOnline from '../../common/withOnline';
import withSelectCaseDate from '../../common/withSelectCaseDate';
import VhnPpcModal from '../../components/Models/VhnPpcModal';
import VrasPpcModal from '../../components/Models/VrasPpcModal';
import withVhnPpcOtherCharge from '../../common/withVhnPpcOtherCharge';
import {
  addComplianceAppData,
  updateCase
} from '../../utils/utils';
import withLoader from '../../common/withLoader';
import CustCaseIDModal from '../../components/Models/CustCaseIDModal';
import RequiredCustCaseID from '../../components/Models/RequiredCustCaseID';

class Products extends Component {
  constructor(props) {
    super(props);

    this.state = {
      casesDetail: [],
      caseDetail: {},
      hospitalUseCustCaseIDStatus: false,
    };

    this.vhnPpcModal = null;
    this.vrasPpcModal = null;
    this.custCaseIDModal = null;
    this.requiredCustCaseIDModal = null;
  }

  componentDidMount() {
    this.vhnPpcModal = new window.bootstrap.Modal(window.$('#vhnPpcModalModal'));
    this.vrasPpcModal = new window.bootstrap.Modal(window.$('#vrasPpcModal'));
    this.custCaseModal = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
    this.requiredCustCaseIDModal = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVhnPpc = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      if (caseDetail.VelysUsed === null) {
        this.vhnPpcModal.show();
      } else if (caseDetail.case_products.length > 0) {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcYes = async () => {
    try {
      const {
        params: { id }, tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VHN-PPC') {
                this._onGoBack();
                browserHistory.push(`/manage-case/${id}/products/add/other-charge`);
              } else {
                browserHistory.push(`/manage-case/${id}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VHN-PPC') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/add/other-charge`);
        } else {
          browserHistory.push(`/manage-case/${id}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcNo = async () => {
    try {
      const {
        params: { id }, tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'NO';
              await updateCase(caseDetail);
              // Update into local db
              updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
              this._onGoBack();
              browserHistory.push(`/manage-case/${id}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Sync = 1;
        caseDetail.VelysUsed = 'NO';
        caseDetail.Submitted = '0';
        // Update into local db
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVrasPpc = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      if (caseDetail.VelysUsed === null) {
        this.vrasPpcModal.show();
      } else if (caseDetail.case_products.length > 0) {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcYes = async () => {
    try {
      const {
        params: { id }, tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VRAS-PPC') {
                this._onGoBack();
                browserHistory.push(`/manage-case/${id}/products/add/other-charge`);
              } else {
                browserHistory.push(`/manage-case/${id}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VRAS-PPC') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/add/other-charge`);
        } else {
          browserHistory.push(`/manage-case/${id}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcNo = async () => {
    try {
      const {
        params: { id }, tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'NO';
              await updateCase(caseDetail);
              // Update into local db
              updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
              this._onGoBack();
              browserHistory.push(`/manage-case/${id}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Sync = 1;
        caseDetail.VelysUsed = 'NO';
        caseDetail.Submitted = '0';
        // Update into local db
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProduct = async () => {
    try {
      const {
        params: { id }, tableName, notify, online, selectedDate, user: { scanner }
      } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);
        const isDGR = caseRes.DGR === '1';

        if (!isDGR) {
          if (
            typeof hosptalRes !== 'undefined'
            && hosptalRes.UseCustCaseID === '1'
            && caseRes.CustCaseID === null
            && (caseRes.ProductSubmitted === null || caseRes.ProductSubmitted !== '1')
          ) {
            this.setState({
              hospitalUseCustCaseIDStatus: true
            });

            this._onCustomerCaseIDStatus();
            return;
          }
        }
      }

      const {
        CaseDate, CaseScheduleID, MRN, PatientID, case_products, DGR, CaseType, ACMCaseID
      } = caseRes;
      let vhnValue = {};

      if (caseRes.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseRes.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnValue = vhnPpc;
        }
      }

      if (online && CaseScheduleID === null) {
        notify({ type: 'error', message: 'Case must be submitted and have a CaseNo before scanning products.', time: 3 });
      } else if (selectedDate > new Date()) {
        notify({ type: 'error', message: 'You can\'t add or view product for a case in the futurettttt.', time: 3 });
      } else if ((MRN === null || MRN === '') && (PatientID === null || PatientID === '')) {
        if (case_products.length > 0 && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== '')) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else if (DGR === '1') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          notify({ type: 'error', message: 'You must enter a Patient ID or MRN before scanning products.', time: 3 });
        }
      } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'HIP' && (vhnValue.VHN_PPC === '1' || vhnValue.VHN_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
        await this._onAddVhnPpc();
      } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'KNEE' && (vhnValue.VRAS_PPC === '1' || vhnValue.VRAS_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
        await this._onAddVrasPpc();
      } else if (online && case_products.length === 0 && DGR === '1' && scanner === true) {
        if (ACMCaseID !== '' && DGR === '1') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/add`);
        }
      } else if (online && case_products.length > 0 && DGR === '1' && scanner === true) {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else if (online && case_products.length > 0 && (scanner === true || scanner === false) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else if (moment(CaseDate) <= moment() && (CaseType === 'HIP' && ((vhnValue.VHN_PPC === '0' && vhnValue.VHN_Other === '0') || Object.keys(vhnValue).length === 0))) {
        this._onGoBack();
        // browserHistory.push(`/manage-case/${id}/products/add`);
        if (case_products.length > 0) {
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          browserHistory.push(`/manage-case/${id}/products/add`);
        }
      } else if (moment(CaseDate) <= moment() && (CaseType === 'KNEE' && ((vhnValue.VRAS_PPC === '0' && vhnValue.VRAS_Other === '0') || Object.keys(vhnValue).length === 0))) {
        if (ACMCaseID !== '' && DGR === '1') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          if (ACMCaseID !== '' && DGR === '0') {
            this._onGoBack();
            if (case_products.length > 0) {
              browserHistory.push(`/manage-case/${id}/products/list`);
            } else {
              browserHistory.push(`/manage-case/${id}/products/add`);
            }
          } else {
            this._onGoBack();
            browserHistory.push(`/manage-case/${id}/products/add`);
          }
        }
      } else if (online && scanner === false && case_products.length === 0) {
        notify({ type: 'error', message: 'No products have been recorded for this case' });
      } else if (online && scanner === false && case_products.length > 0) {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onCustomerCaseIDAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, setGoBack, goBack
      } = this.props;
      const {
        params: { id }, selectedDate, user: { scanner }
      } = this.props;

      const caseRes = await getTableCaseByCaseId(id, tableName);

      const {
        CaseDate, CaseScheduleID, MRN, PatientID, case_products, DGR, CaseType, ACMCaseID
      } = caseRes;
      let vhnValue = {};

      // if (online && caseRes && caseRes.DGR === '1') {
      //   this.caseChangesNoLonger.show();
      //   return;
      // }

      if (caseRes.CustomerName !== null) {
        vhnValue = await getVhnPpcValue(caseRes.CustomerName);
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextCustomerCaseIDStatus();
        return;
      }

      if (formData.hasOwnProperty('CustCaseID')) {
        caseRes.CustCaseID = (formData.CustCaseID !== null || formData.CustCaseID !== undefined)
          ? formData.CustCaseID
          : null;
      }

      if (online) {
        setLoader(true);
        const newArrayOfObj = caseRes.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        caseRes.selectSets = newArrayOfObj;
        caseRes.Submitted = '0';
        caseRes.Synced = '0';
        updateCase(caseRes).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              goBack.push(window.location.pathname);
              setGoBack(goBack);

              if (online && CaseScheduleID === null) {
                notify({ type: 'error', message: 'Case must be submitted and have a CaseNo before scanning products.', time: 3 });
              } else if (selectedDate > new Date()) {
                notify({ type: 'error', message: 'You can\'t add or view product for a case in the futurettttt.', time: 3 });
              } else if ((MRN === null || MRN === '') && (PatientID === null || PatientID === '')) {
                if (case_products.length > 0 && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== '')) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
                  this._onGoBack();
                  browserHistory.push(`/manage-case/${id}/products/list`);
                } else if (DGR === '1') {
                  this._onGoBack();
                  browserHistory.push(`/manage-case/${id}/products/list`);
                } else {
                  notify({ type: 'error', message: 'You must enter a Patient ID or MRN before scanning products.', time: 3 });
                }
              } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'HIP' && (vhnValue.VHN_PPC === '1' || vhnValue.VHN_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
                await this._onAddVhnPpc();
              } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'KNEE' && (vhnValue.VRAS_PPC === '1' || vhnValue.VRAS_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
                await this._onAddVrasPpc();
              } else if (online && case_products.length === 0 && DGR === '1' && scanner === true) {
                if (ACMCaseID !== '' && DGR === '1') {
                  this._onGoBack();
                  browserHistory.push(`/manage-case/${id}/products/list`);
                } else {
                  this._onGoBack();
                  browserHistory.push(`/manage-case/${id}/products/add`);
                }
              } else if (online && case_products.length > 0 && DGR === '1' && scanner === true) {
                this._onGoBack();
                browserHistory.push(`/manage-case/${id}/products/list`);
              } else if (online && case_products.length > 0 && (scanner === true || scanner === false) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
                this._onGoBack();
                browserHistory.push(`/manage-case/${id}/products/list`);
              } else if (moment(CaseDate) <= moment() && (CaseType === 'HIP' && ((vhnValue.VHN_PPC === '0' && vhnValue.VHN_Other === '0') || Object.keys(vhnValue).length === 0))) {
                this._onGoBack();
                if (case_products.length > 0) {
                  browserHistory.push(`/manage-case/${id}/products/list`);
                } else {
                  browserHistory.push(`/manage-case/${id}/products/add`);
                }
              } else if (moment(CaseDate) <= moment() && (CaseType === 'KNEE' && ((vhnValue.VRAS_PPC === '0' && vhnValue.VRAS_Other === '0') || Object.keys(vhnValue).length === 0))) {
                if (ACMCaseID !== '' && DGR === '1') {
                  this._onGoBack();
                  browserHistory.push(`/manage-case/${id}/products/list`);
                } else {
                  if (ACMCaseID !== '' && DGR === '0') {
                    this._onGoBack();
                    if (case_products.length > 0) {
                      browserHistory.push(`/manage-case/${id}/products/list`);
                    } else {
                      browserHistory.push(`/manage-case/${id}/products/add`);
                    }
                  } else {
                    this._onGoBack();
                    browserHistory.push(`/manage-case/${id}/products/add`);
                  }
                }
              } else if (online && scanner === false && case_products.length === 0) {
                notify({ type: 'error', message: 'No products have been recorded for this case' });
              } else if (online && scanner === false && case_products.length > 0) {
                this._onGoBack();
                browserHistory.push(`/manage-case/${id}/products/list`);
              } else {
                this._onGoBack();
                browserHistory.push(`/manage-case/${id}/products/add`);
              }
            }

            // Update into local db
            updateTableCaseByPrimaryId(caseRes.id, caseRes, tableName);
            updateTableWiseCaseByCaseId(caseRes.RepCaseNo, caseRes, tableName);
            this.setState({ caseRes });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        setLoader(true);
        goBack.push(window.location.pathname);
        setGoBack(goBack);
        caseRes.Sync = 1;

        if (online && CaseScheduleID === null) {
          notify({ type: 'error', message: 'Case must be submitted and have a CaseNo before scanning products.', time: 3 });
        } else if (selectedDate > new Date()) {
          notify({ type: 'error', message: 'You can\'t add or view product for a case in the futurettttt.', time: 3 });
        } else if ((MRN === null || MRN === '') && (PatientID === null || PatientID === '')) {
          if (case_products.length > 0 && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== '')) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
            this._onGoBack();
            browserHistory.push(`/manage-case/${id}/products/list`);
          } else if (DGR === '1') {
            this._onGoBack();
            browserHistory.push(`/manage-case/${id}/products/list`);
          } else {
            notify({ type: 'error', message: 'You must enter a Patient ID or MRN before scanning products.', time: 3 });
          }
        } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'HIP' && (vhnValue.VHN_PPC === '1' || vhnValue.VHN_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
          await this._onAddVhnPpc();
        } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'KNEE' && (vhnValue.VRAS_PPC === '1' || vhnValue.VRAS_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
          await this._onAddVrasPpc();
        } else if (online && case_products.length === 0 && DGR === '1' && scanner === true) {
          if (ACMCaseID !== '' && DGR === '1') {
            this._onGoBack();
            browserHistory.push(`/manage-case/${id}/products/list`);
          } else {
            this._onGoBack();
            browserHistory.push(`/manage-case/${id}/products/add`);
          }
        } else if (online && case_products.length > 0 && DGR === '1' && scanner === true) {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else if (online && case_products.length > 0 && (scanner === true || scanner === false) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else if (moment(CaseDate) <= moment() && (CaseType === 'HIP' && ((vhnValue.VHN_PPC === '0' && vhnValue.VHN_Other === '0') || Object.keys(vhnValue).length === 0))) {
          this._onGoBack();
          if (case_products.length > 0) {
            browserHistory.push(`/manage-case/${id}/products/list`);
          } else {
            browserHistory.push(`/manage-case/${id}/products/add`);
          }
        } else if (moment(CaseDate) <= moment() && (CaseType === 'KNEE' && ((vhnValue.VRAS_PPC === '0' && vhnValue.VRAS_Other === '0') || Object.keys(vhnValue).length === 0))) {
          if (ACMCaseID !== '' && DGR === '1') {
            this._onGoBack();
            browserHistory.push(`/manage-case/${id}/products/list`);
          } else {
            if (ACMCaseID !== '' && DGR === '0') {
              this._onGoBack();
              if (case_products.length > 0) {
                browserHistory.push(`/manage-case/${id}/products/list`);
              } else {
                browserHistory.push(`/manage-case/${id}/products/add`);
              }
            } else {
              this._onGoBack();
              browserHistory.push(`/manage-case/${id}/products/add`);
            }
          }
        } else if (online && scanner === false && case_products.length === 0) {
          notify({ type: 'error', message: 'No products have been recorded for this case' });
        } else if (online && scanner === false && case_products.length > 0) {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/add`);
        }

        updateTableCaseByPrimaryId(caseRes.id, caseRes, tableName);
        updateTableWiseCaseByCaseId(caseRes.RepCaseNo, caseRes, tableName);
        setLoader(false);
        this.setState({ caseRes });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDBack = async () => {
    try {
      const {
        params: { id }, tableName, notify, online, selectedDate, user: { scanner }
      } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);

      const {
        CaseDate, CaseScheduleID, MRN, PatientID, case_products, DGR, CaseType, ACMCaseID
      } = caseRes;
      let vhnValue = {};

      if (caseRes.CustomerName !== null) {
        // vhnValue = await getVhnPpcValue(caseRes.CustomerName);
        const vhnPpc = await getVhnPpcValue(caseRes.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnValue = vhnPpc;
        }
      }

      if (online && CaseScheduleID === null) {
        notify({ type: 'error', message: 'Case must be submitted and have a CaseNo before scanning products.', time: 3 });
      } else if (selectedDate > new Date()) {
        notify({ type: 'error', message: 'You can\'t add or view product for a case in the futurettttt.', time: 3 });
      } else if ((MRN === null || MRN === '') && (PatientID === null || PatientID === '')) {
        if (case_products.length > 0 && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== '')) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else if (DGR === '1') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          notify({ type: 'error', message: 'You must enter a Patient ID or MRN before scanning products.', time: 3 });
        }
      } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'HIP' && (vhnValue.VHN_PPC === '1' || vhnValue.VHN_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
        await this._onAddVhnPpc();
      } else if (online && (case_products.length === 0 || case_products.length > 0) && (CaseType === 'KNEE' && (vhnValue.VRAS_PPC === '1' || vhnValue.VRAS_Other === '1')) && ((MRN !== null && MRN !== '') || (PatientID !== null && PatientID !== ''))) {
        await this._onAddVrasPpc();
      } else if (online && case_products.length === 0 && DGR === '1' && scanner === true) {
        if (ACMCaseID !== '' && DGR === '1') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/add`);
        }
      } else if (online && case_products.length > 0 && DGR === '1' && scanner === true) {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else if (online && case_products.length > 0 && (scanner === true || scanner === false) && CaseType !== 'HIP' && CaseType !== 'KNEE') {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else if (moment(CaseDate) <= moment() && (CaseType === 'HIP' && ((vhnValue.VHN_PPC === '0' && vhnValue.VHN_Other === '0') || Object.keys(vhnValue).length === 0))) {
        this._onGoBack();
        if (case_products.length > 0) {
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          browserHistory.push(`/manage-case/${id}/products/add`);
        }
      } else if (moment(CaseDate) <= moment() && (CaseType === 'KNEE' && ((vhnValue.VRAS_PPC === '0' && vhnValue.VRAS_Other === '0') || Object.keys(vhnValue).length === 0))) {
        if (ACMCaseID !== '' && DGR === '1') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${id}/products/list`);
        } else {
          if (ACMCaseID !== '' && DGR === '0') {
            this._onGoBack();
            if (case_products.length > 0) {
              browserHistory.push(`/manage-case/${id}/products/list`);
            } else {
              browserHistory.push(`/manage-case/${id}/products/add`);
            }
          } else {
            this._onGoBack();
            browserHistory.push(`/manage-case/${id}/products/add`);
          }
        }
      } else if (online && scanner === false && case_products.length === 0) {
        notify({ type: 'error', message: 'No products have been recorded for this case' });
      } else if (online && scanner === false && case_products.length > 0) {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/list`);
      } else {
        this._onGoBack();
        browserHistory.push(`/manage-case/${id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onNextCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  render() {
    const { goBack, params: { id } } = this.props;
    return (
      <section className="list-section resizer-class">
        <Header
          title="Product"
          goBack={() => onGoBack(goBack)}
        />
        <div className="site-wrapper">
          <section className="acm-section">
            <div className="container">
              <div className="acm-button-block">
                <div className="row h-100">
                  <div className="col align-self-center">
                    <Link
                      to={`/manage-case/${id}/acm-products`} onClick={this._onGoBack}
                      className="btn btn-theme-alt btn-theme-outline-alt  d-block btn-max-width"
                    > Planned / Selected
                    </Link>
                    <Link
                      onClick={this._onProduct}
                      className="btn btn-theme-alt btn-theme-outline-alt  d-block btn-max-width"
                    > Used In Surgery
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <VhnPpcModal
          onClickNo={this._onClickVhnPpcNo}
          onClickYes={this._onClickVhnPpcYes}
        />
        <VrasPpcModal
          onClickNo={this._onClickVrasPpcNo}
          onClickYes={this._onClickVrasPpcYes}
        />

        <CustCaseIDModal
          onSubmit={this._onCustomerCaseIDAdd}
          onBack={this._onCustomerCaseIDBack}
        />
        <RequiredCustCaseID onClickOk={this._onCustomerCaseIDStatus} />
      </section>
    );
  }
}

export default withLoader(
  withVhnPpcOtherCharge(
    withSelectCaseDate(
      withOnline(
        withNotify(
          withUser(
            withTableName(
              withGoBack(
                Products
              )
            )
          )
        )
      )
    )
  )
);
